import { render, staticRenderFns } from "./_top.vue?vue&type=template&id=6c78bdc0&"
import script from "./_top.vue?vue&type=script&lang=js&"
export * from "./_top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports